export default "__VITE_PUBLIC_ASSET__a4699a9b__"